import { Link } from "react-router-dom";

const NotAuthorized = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col justify-center items-center px-4">
      <h1 className="text-4xl font-bold text-red-600 mb-4">Unauthorized</h1>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        Access Denied
      </h2>
      <p className="text-gray-600 mb-8">
        Sorry, you don't have permission to access this page. Please contact
        your administrator if you believe this is an error.
      </p>
      <Link
        to="/"
        className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded transition duration-300"
      >
        Return to Home
      </Link>
    </div>
  );
};

export default NotAuthorized;
